import React from 'react';
import Hero from '../components/Hero';
import Skills from '../components/Skills';
import Projects from '../components/Projects';

const Home = () => {
  return (
    <div>
      <Hero />
      <Skills />
      <Projects />
    </div>
  );
};

export default Home;
